import { jsx as _jsx } from "react/jsx-runtime";
export default function RecordJobTransfer(_a) {
    var transfers = _a.transfers;
    return _jsx("div", { children: transfers.map(function (jobTransfer) { return jobTransfer.transferNumber; }).join(', ') });
}
